export const ACTION_SAVE_COMMANDS_PAGINATED = 'ACTION_SAVE_COMMANDS_PAGINATED';
export const ACTION_SAVE_COMMAND_DETAILS = 'ACTION_SAVE_COMMAND_DETAILS';
export const ACTION_SAVE_COMMAND_HISTORY = 'ACTION_SAVE_COMMAND_HISTORY';
export const ACTION_CLEAN_COMMAND = 'CLEAN_COMMAND';
export const ACTION_ALTER_COMMAND = 'ACTION_ALTER_COMMAND';